module.exports = "/_next/static/images/game-2-intro-uv-tutorial3-3ae8946e5293dd8bbbffaba3de25c4ce.png";